import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M21 4H3v16h18V4zm-2 14H5V6h14v12z"
}), 'Crop32Sharp');